import { render, staticRenderFns } from "./week-schedule.vue?vue&type=template&id=45853c53"
import script from "./week-schedule.vue?vue&type=script&lang=js"
export * from "./week-schedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports